export const FOOTER_OFFER_COMPONENT = 'roomDetailsStaticOfferCTA'
